const POST_LOGIN_REDIRECT_KEY = 'legal-web:post-login-redirect'
export const DEFAULT_POST_LOGIN_PATH = '/u/ai-doc'

export function resolvePostLoginRedirect(search: string): string {
  return normalizePostLoginPath(new URLSearchParams(search).get('redirectTo'))
}

export function savePostLoginRedirect(path: string): void {
  try {
    window.sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, normalizePostLoginPath(path))
  } catch {
    // sessionStorage 不可用时退回默认登录落点
  }
}

export function consumePostLoginRedirect(): string {
  try {
    const value = window.sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY)
    window.sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
    return normalizePostLoginPath(value)
  } catch {
    return DEFAULT_POST_LOGIN_PATH
  }
}

export function normalizePostLoginPath(path: string | null | undefined): string {
  if (!path) return DEFAULT_POST_LOGIN_PATH

  try {
    const url = new URL(path, window.location.origin)
    if (url.origin !== window.location.origin) return DEFAULT_POST_LOGIN_PATH
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return path.startsWith('/') && !path.startsWith('//') ? path : DEFAULT_POST_LOGIN_PATH
  }
}
